import { getCurrentClientEnvironment } from "./clientEnvironment";
import { getTeamPresencePathname, subscribeTeamPresenceRoute } from "./teamPresenceRouteStore";

export const TEAM_PRESENCE_CLIENT_XPRO4 = "xpro4";

const TAB_KEY = "xpro4_team_presence_tab";

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `t-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Identificador estável por aba do navegador (para o snapshot listar cada aba do Xpro 4). */
export function getTeamPresenceTabInstanceId() {
  try {
    let id = sessionStorage.getItem(TAB_KEY);
    if (!id) {
      id = randomId();
      sessionStorage.setItem(TAB_KEY, id);
    }
    return id;
  } catch {
    return randomId();
  }
}

let routeEnteredAtMs = Date.now();
let lastTrackedPath = "";

function syncRouteEntered() {
  const p = getTeamPresencePathname();
  if (p !== lastTrackedPath) {
    lastTrackedPath = p;
    routeEnteredAtMs = Date.now();
    /* Nova rota: "sem interação" recomeça junto com "nesta tela" até o próximo input */
    const now = Date.now();
    lastActivityAtMs = now;
    lastActivityBumpMs = now;
  }
}

subscribeTeamPresenceRoute(() => {
  syncRouteEntered();
});

let lastActivityAtMs = Date.now();
let lastActivityBumpMs = 0;
const ACTIVITY_THROTTLE_MS = 5000;

export function bumpTeamPresenceActivity() {
  const now = Date.now();
  if (now - lastActivityBumpMs < ACTIVITY_THROTTLE_MS) return;
  lastActivityBumpMs = now;
  lastActivityAtMs = now;
}

if (typeof window !== "undefined") {
  const opts = { passive: true, capture: true };
  for (const ev of ["pointerdown", "keydown", "touchstart"]) {
    window.addEventListener(ev, bumpTeamPresenceActivity, opts);
  }
}

function isBrowserTabFocused() {
  if (typeof document === "undefined") return false;
  return !document.hidden && document.visibilityState === "visible" && document.hasFocus();
}

/**
 * Snapshot de tempo na rota atual (para analytics de uso do produto).
 */
export function getProductUsageTimingSnapshot() {
  syncRouteEntered();
  const now = Date.now();
  return {
    path: getTeamPresencePathname(),
    durationSeconds: Math.max(0, Math.round((now - routeEnteredAtMs) / 1000)),
    focused: isBrowserTabFocused(),
    routeEnteredAtMs,
    nowMs: now,
  };
}

/**
 * Payload extra para socket.emit('users') no Xpro 4 (o servidor replica para o workspace).
 * @param {{ id: number|string, name: string, workspace: string }} base
 */
export function buildTeamPresenceXpro4Payload(base) {
  syncRouteEntered();
  const { deviceType, browserName, appVersion, appTheme } = getCurrentClientEnvironment();
  return {
    ...base,
    client: TEAM_PRESENCE_CLIENT_XPRO4,
    tab: getTeamPresenceTabInstanceId(),
    path: getTeamPresencePathname(),
    since: new Date(routeEnteredAtMs).toISOString(),
    lastActivityAt: new Date(lastActivityAtMs).toISOString(),
    focused: isBrowserTabFocused(),
    deviceType,
    browserName,
    appVersion,
    appTheme,
  };
}
